import { contrastRatio } from "./colorSystemPresentation.mjs";

export function logoSourcesCurrent(palette, typography) {
  const selection = typography?.selected_system;
  return Boolean(palette?.status === "approved" && selection?.status === "approved"
    && selection.preferences_fingerprint === typography.preferences_fingerprint
    && selection.palette_fingerprint === palette.source_fingerprint
    && selection.palette_version === palette.version_number);
}

export function defaultLogoComposition(palette, signature, weights = [], styles = []) {
  const colors = palette.colors;
  const light = colors.find((color) => color.role === "primary_light") || colors.find((color) => color.role === "neutral") || [...colors].sort((a, b) => contrastRatio("#000000", b.hex) - contrastRatio("#000000", a.hex))[0];
  const dark = colors.find((color) => color.role === "primary_dark");
  if (!light || !dark) return null;
  return {
    font_role: "signature", font_weight: weights.includes(signature.font_weight) ? signature.font_weight : weights[0],
    font_style: styles.includes(signature.font_style) ? signature.font_style : styles[0],
    text_transform: signature.text_transform || "none", letter_spacing_em: signature.letter_spacing_em || 0,
    layout: "single_line", alignment: "center", color_hex: dark.hex,
    light_background_hex: light.hex, dark_background_hex: dark.hex, dark_color_hex: light.hex,
  };
}

export function logoLines(brandName, composition) {
  const text = composition.text_transform === "uppercase" ? brandName.toUpperCase() : brandName;
  if (composition.variant === "initials") return [logoInitials(brandName)];
  if (composition.variant === "compact" && text.trim().split(/\s+/).length > 1) {
    const words = text.trim().split(/\s+/);
    return [words.slice(0, -1).map((word) => `${word[0]}.`).join(" "), words[words.length - 1]];
  }
  if (composition.layout !== "stacked" || text.trim().split(/\s+/).length < 2) return [text];
  const words = text.trim().split(/\s+/);
  const midpoint = Math.ceil(words.length / 2);
  return [words.slice(0, midpoint).join(" "), words.slice(midpoint).join(" ")];
}

export function logoContrast(composition) {
  return Math.min(contrastRatio(composition.color_hex, composition.light_background_hex),
    contrastRatio(composition.dark_color_hex, composition.dark_background_hex));
}


export function logoInitials(name) {
  const words = name.trim().split(/\s+/);
  return words.length > 1 ? `${Array.from(words[0])[0]}${Array.from(words[words.length - 1])[0]}`.toUpperCase() : "";
}

export function curatedLogoVariants(name, base) {
  const choices = [
    { id: "wordmark", title: "Чистый wordmark", caption: "Спокойная фирменная подпись.", composition: { ...base, variant: "wordmark", descriptor: "" } },
    { id: "descriptor", title: "С подписью", caption: "Показывает характер проекта.", composition: { ...base, variant: "descriptor", descriptor: base.descriptor || "" } },
  ];
  if (logoInitials(name)) choices.push({ id: "initials", title: "Инициалы", caption: "Для небольших носителей.", composition: { ...base, variant: "initials", descriptor: "", layout: "single_line", letter_spacing_em: 0 } });
  if (name.trim().split(/\s+/).length > 1) choices.push({ id: "compact", title: "Компактная версия", caption: "Короткая композиция для малого размера.", composition: { ...base, variant: "compact", descriptor: "", layout: "stacked", letter_spacing_em: 0 } });
  return choices;
}

// Weight alone does not measure stroke thickness. Flag a known light display
// character conservatively; never promise legibility or synthesize a new face.
export function smallLogoAdvice(composition, font = {}) {
  if (composition.font_weight < 400 || (font.category === "display" && composition.font_weight === 400) || font.id === "poiret-one")
    return "В небольшом размере этот вариант может быть слишком тонким. Сравни компактную версию и проверь реальное применение.";
  if (Math.abs(composition.letter_spacing_em) > .15)
    return "В небольшом размере проверь читаемость межбуквенных интервалов.";
  return "Проверь читаемость в реальном небольшом размере.";
}
